import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const Guarantee = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-47">
      <div className="container mx-auto px-4" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="relative max-w-[600px] mx-auto bg-[#111111] rounded-2xl p-8 md:p-10 text-center overflow-hidden" style={{
          borderTop: '3px solid transparent',
          backgroundImage: 'linear-gradient(#111111, #111111), linear-gradient(90deg, #ADFF2F, #6ECC1F, #ADFF2F)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box'
        }} data-id="element-50">
            {/* Shield circle */}
            <div className="w-20 h-20 rounded-full bg-[#ADFF2F] flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(173,255,47,0.4)]" data-id="element-51">
              <span className="text-4xl" data-id="element-52">🛡️</span>
            </div>

            {/* Badge */}
            <div className="inline-block border border-[#ADFF2F] text-[#ADFF2F] text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans" data-id="element-53">
              Garantía Total de 7 Días
            </div>

            {/* Heading */}
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-5 leading-tight" data-id="element-54">
              🛡️ Pruébalo sin riesgo. Si no te sirve, te devuelvo cada centavo.
            </h3>

            {/* Body */}
            <p className="text-gray-400 text-base md:text-lg leading-relaxed mb-3 font-sans max-w-md mx-auto" data-id="element-55">
              Tienes 7 días completos para aplicar el plan y ver los resultados.
            </p>
            <p className="text-gray-400 text-base md:text-lg leading-relaxed mb-6 font-sans max-w-md mx-auto" data-id="element-56">
              Si por cualquier razón no estás satisfecho, escríbeme y te hago la
              devolución completa. Sin formularios. Sin preguntas. Sin
              complicaciones.
            </p>

            {/* Divider */}
            <div className="h-px bg-white/10 my-6 max-w-xs mx-auto" data-id="element-57" />

            {/* Closing line */}
            <p className="text-[#ADFF2F] font-bold text-base md:text-lg font-sans m-0" data-id="element-58">
              ⚡ El riesgo es cero. Todo tuyo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};